import apiFetch from '@wordpress/api-fetch'
import {createContext, useState} from 'react'
import {useNavigate} from 'react-router-dom'

const AppContext = createContext({
})

export const AppContextProvider = ({ children, form }) => {
  const [typeOfRequest, setTypeOfRequest] = useState(null)
  const [state, setState] = useState({})
  const navigate = useNavigate()

  return (
    <AppContext.Provider
      value={{
        form,

        typeOfRequest,
        setTypeOfRequest,

        state,
        ...state,
        setState (newState) {
          setState({...newState})
        },
        applyState (moreState) {
          for (const [key, value] of Object.entries(moreState)) {
            state[key] = value
          }
          setState({...state})
        },

        async submit () {
          console.log('submitting', typeOfRequest, state)

          if (!form?.id) {
            console.error("Form data or form ID is missing.")
            return
          }

          const getFormData = () => {
            if (!form) return

            const titleFieldId = form.fields.find(field => field.label === 'Title')?.id
            const emailFieldId = form.fields.find(field => field.label === 'Email')?.id
            const typeOfRequestFieldId = form.fields.find(field => field.label === 'Type of request')?.id
            const answersFieldId = form.fields.find(field => field.label === 'Answers')?.id
            const fileFieldIds = form.fields.filter(field => field.label === 'File').map(field => field.id)

            const formData = new FormData()

            formData.append(
              `input_${titleFieldId}`,
              (typeOfRequest) +
              (state['Etu- ja sukunimi'] ? (' ' + state['Etu- ja sukunimi']) : '')
            )

            if (emailFieldId && state['Sähköposti']) {
              formData.append(
                `input_${emailFieldId}`,
                state['Sähköposti']
              )
            }

            formData.append(
              `input_${typeOfRequestFieldId}`,
              (typeOfRequest)
            )

            let fileIndex = 0
            let answerIndex = 0

            for (const [key, value] of Object.entries(state)) {
              if (value instanceof File) {
                formData.append(`input_${fileFieldIds[fileIndex++]}`, value)
              } else if (typeof value === 'boolean') {
                formData.append(
                  `input_${answersFieldId}[${answerIndex++}]`,
                  `${key}: ${value ? 'Kyllä' : 'Ei'}`
                )
              } else if (Array.isArray(value)) {
                formData.append(
                  `input_${answersFieldId}[${answerIndex++}]`,
                  key + ': ' +
                  value.map(value => (
                    typeof value === 'string' ? (
                      `${key}: ${value}`
                    ) : typeof value === 'number' ? (
                      `${key}: ${value}`
                    ) : typeof value === 'object' ? (
                      Object.entries(value).map(([key, value]) => (
                        `${key}: ${value}`
                      )).join(', ')
                    ) : ''
                  )).join('; ')
                )
              } else {
                formData.append(
                  `input_${answersFieldId}[${answerIndex++}]`,
                  `${key}: ${value}`
                )
              }
            }

            return formData
          }

          await doRequest(getFormData(), form.id)
        }
      }}
    >
      {children}
    </AppContext.Provider>
  )
}

export default AppContext

const doRequest = async (formData, formId) => {
  try {
    const response = await apiFetch({
      path: `/gf/v2/forms/${formId}/submissions`,
      method: 'POST',
      body: formData,
    })
    return response
  } catch (error) {
    console.error("Error submitting form:", error)
    throw error
  }
}
